import { COLUMN_CODE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const SiteCodeColumns: TableColumn[] = [
    {
        heading: "Code",
        accessor: "code",
        isNumeric: false,
        id: 0,
        sortByName: "siteCode",
        sortDirection: "asc",
        active: true,
        translationKey: "code",
        columnId: COLUMN_CODE,
    },
    // {
    //     heading: "Host IP",
    //     accessor: "hostIP",
    //     isNumeric: false,
    //     id: 1,
    //     sortByName: "siteHostip",
    //     sortDirection: "asc",
    //     active: true,
    // },
    // {
    //     heading: "Time Zone",
    //     accessor: "timeZone",
    //     isNumeric: false,
    //     id: 2,
    //     sortByName: "timeZone.zone",
    //     sortDirection: "asc",
    //     active: true,
    //     searchOnName: "timeZone.zone",
    //     lookupName: "timeZone.zone"
    // },
    // {
    //     heading: "Tag Mask",
    //     accessor: "tagmask",
    //     isNumeric: false,
    //     id: 3,
    //     sortByName: "siteTagmask",
    //     sortDirection: "asc",
    //     active: true,
    // },
];

export default SiteCodeColumns
